import { SEND_CHAT_MESSAGE as SOCKET_SEND_CHAT_MESSAGE } from '../../events/ClientToServer'

const SEND_CHAT_MESSAGE = 'SEND_CHAT_MESSAGE'
const RECEIVED_CHAT_MESSAGE = 'RECEIVED_CHAT_MESSAGE'

export const chatMessages = (state = [], action) => {
    switch (action.type) {
        case RECEIVED_CHAT_MESSAGE:
            return [...state, action.message]
 
        default:
            return state
    }
}

export const sendChatMessage = (socket, message) => {
    socket.emit(SOCKET_SEND_CHAT_MESSAGE, { message })
    return { type: SEND_CHAT_MESSAGE, message }
}

export const receivedChatMessage = (message) => {
    return { type: RECEIVED_CHAT_MESSAGE, message }
}



// WEBPACK FOOTER //
// ./src/reducers/chatMessages/index.js